import { render, staticRenderFns } from "./CarImport.vue?vue&type=template&id=2143c22a&scoped=true"
import script from "./CarImport.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarImport.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarImport.vue?vue&type=style&index=0&id=2143c22a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2143c22a",
  null
  
)

export default component.exports